import React from 'react';

export const renderText = (children) => {
  return children.map((child, i) => {
    let element = child.text;

    if (child.bold) element = <strong>{element}</strong>;
    if (child.italic) element = <em>{element}</em>;
    if (child.underline) element = <u>{element}</u>;
    if (child.strikethrough) element = <s>{element}</s>;

    return <React.Fragment key={i}>{element}</React.Fragment>;
  });
};
